import {productSvg as Icon__small__productSvg} from '../Icon__small/Icon__small--product.js'

export var product = {
  name: 'product',
  category: 'icon',
  colorable: true,
  svg: Icon__small__productSvg,
};
